import { SaveCreditCard } from '@/domain/usecases'
import { RemoteSaveCreditCard } from '@/data/usecases'
import { makeAxiosHttpClient } from '@/main/factories/http'
import env from '@/main/config/env'

export const makeSaveCreditCard = (): SaveCreditCard => {
  const url = env.API_URL
  const httpClient = makeAxiosHttpClient<string>()

  return new RemoteSaveCreditCard(url, httpClient)
}
